export default "__VITE_ASSET__fa47f066__"